import actions from './actions'
import * as types from './types'

const state = {
  isEditMode: false,
  data: [],
  selectedCountry: '',
  supportedCountries: [],
  partner: {},
  pricing: {},
  pricingToSaved: {},
  recourse: null,
  isConfigNotFound: false
}

const mutations = {
  [types.SET_IS_EDIT_MODE]: function (state, value) {
    state.isEditMode = value
  },
  [types.SET_SELECTED_COUNTRY](state, value) {
    state.selectedCountry = value
  },
  [types.SET_SUPPORTED_COUNTRIES](state, value) {
    state.supportedCountries = value
  },
  [types.SET_PRICING]: function (state, value) {
    state.pricing = value
  },
  [types.SET_PRICING_TO_SAVED]: function (state, { key, value, grade }) {
    if (key) {
      if (grade) {
        state.pricingToSaved = {
          ...state.pricingToSaved,
          [state.selectedCountry]: {
            ...state.pricingToSaved[state.selectedCountry],
            [key]: {
              ...state.pricingToSaved[state.selectedCountry][key],
              [grade]: value
            }
          }
        }
      } else {
        state.pricingToSaved = {
          ...state.pricingToSaved,
          [state.selectedCountry]: {
            ...state.pricingToSaved[state.selectedCountry],
            [key]: value
          }
        }
      }
    } else {
      state.pricingToSaved = value
    }
  },
  [types.SET_RECOURSE_TO_SAVED]: function (state, recourse) {
    state.recourse = recourse
  },
  [types.SET_IS_CONFIG_NOT_FOUND]: function (state, newValue) {
    state.isConfigNotFound = newValue
  }
}

export default {
  state,
  mutations,
  actions
}
